<template>
  <el-row>
    <el-col>
      <RabbeyTable4
        :border="true"
        :stripe="true"
        ref="table"
        url="/api/Calendar/getAll"
        :request-config="requestConfig"
        :columns="mapColumns"
        :summary-method="getSummaries"
        :classTable="{
          'table-box': true,
          'card-base': true,
          'card-shadow--medium': false
        }"
      />
    </el-col>
    <deal-report-detail
      whatsThisReportFor="agenda"
      ref="detail"
      @getUpdatedData="refreshData"
    />
  </el-row>
</template>

<script>
import HyperLinkAgenda from "@/components/functionals/HyperlinkAgenda.vue";
import DealReportDetail from "./DealReportDetail.vue";
import RabbeyTable4 from "@/components/RabbeyTable4.vue";
import { MONTHS_LIST_WITH_WIDTH } from "@/const";
import { formatMonto } from "@/utils";
import ImagePersonVue from "@/components/functionals/ImagePerson.vue";

export default {
  name: "DealReportAgenda",
  components: {
    DealReportDetail,
    RabbeyTable4
  },
  props: {
    year: {
      type: Number,
      default: new Date().getFullYear()
    }
  },
  data() {
    return {
      columns: [
        {
          prop: "NameEmployee",
          label: "Vendedor",
          fixed: true,
          minWidth: 260,
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "PhotoEmployee"
          },
          sortable: true
        }
      ],
      mountFormatter: new Intl.NumberFormat("en-US", {
        style: "decimal"
      })
    };
  },
  computed: {
    title() {
      if (this.module !== null && this.module === "call-center") {
        return "agente";
      }

      return "vendedor";
    },
    mapColumns() {
      let columns = this.columns;
      for (let i = 0; i < 12; i++) {
        const month = MONTHS_LIST_WITH_WIDTH[i];
        columns.push({
          prop: month.label,
          label: this.$t(`months.${month.label}`),
          name: this.$t(`months.${month.label}`),
          attrs: {
            openDetail: this.openSelect,
            getType: this.getType,
            month: i + 1
          },
          formatter: HyperLinkAgenda,
          minWidth: month.width,
          sortable: true
        });
      }
      /*columns.push({
        prop: "Totals",
        label: "Total",
        name: "Total",
        attrs: {
          isTotal: true,
          openSelect: this.openSelect,
          getType: this.getType,
          month: 0
        },
        formatter: HyperLinkAgenda,
        minWidth: 110,
        sortable: true
      });*/

      return columns;
    },
    requestConfig() {
      return {
        params: {
          year: this.year
        }
      };
    }
  },
  methods: {
    formatMonto,
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        const values = data.map((item) => item[column.property]);
        sums[index] = values.reduce((prev, curr) => {
          if (typeof prev == typeof "") {
            prev = parseFloat(prev.replace(",", ""));
          }
          curr = parseFloat(curr.replace(",", ""));
          const value = parseFloat(curr);
          if (value) {
            let sum = prev + curr;
            sum = this.mountFormatter.format(sum);
            return sum;
          } else {
            return this.mountFormatter.format(prev);
          }
        }, 0);
      });
      return sums;
    },
    openSelect(props, mes) {
      this.$refs.detail.show({
        PhaseID: this.phaseId,
        BySeller: this.module !== "call-center",
        Month: mes,
        Year: this.year,
        ...props
      });
    },
    handleChangeType() {
      this.$nextTick(() => {
        this.$refs.table.table().doLayout();
      });
    },
    refreshData() {
      this.$refs.table.refreshTable();
    }
  }
};
</script>
